import React from "react";
// Styles
import { Wrapper, Content } from "./Infos.styles";

const Infos = () => (
  <Wrapper>
    <Content>
      <h1>+ d&apos;infos</h1>
      <h4>Lien vers page planeur</h4>
      <h4>Lien vers ffvp</h4>
    </Content>
  </Wrapper>
);

export default Infos;
